import { RouteComponentProps } from '@reach/router';
import { sort } from 'ramda';
import React from 'react';
import styled, { css } from 'styled-components';
import { scrollBarStyles } from '~/components/OverflowScrollWrapper';
import SelectBlock from '~/components/SelectBlock';
import { FlowTemplates } from '~/graphql/types';
import { FlowTemplatesCategory } from '../../index';
import TEST_ID from './index.testid';

type Props = RouteComponentProps<{ slug: string }> & {
  flowCategories: FlowTemplatesCategory;
  onSelect: (selectedTemplate: FlowTemplates | null) => void;
  templateId?: string | null;
};

const TemplateDetails: React.FC<Props> = ({
  slug,
  flowCategories,
  templateId,
  onSelect,
}) => {
  const currentCategory: FlowTemplatesCategory['key'] = !slug
    ? flowCategories['meest-gebruikt']
    : flowCategories[slug];

  const sortedTemplates = currentCategory?.templates
    ? sort(({ name: a, weight: wA = 0 }, { name: b, weight: wB = 0 }) => {
        if (wA === wB) return a.localeCompare(b);
        return wB - wA;
      }, currentCategory.templates)
    : [];

  return (
    <Container>
      {sortedTemplates.map(template => (
        <SelectBlock
          type="radio"
          key={template.id}
          checked={templateId === template.id}
          onClick={() => onSelect(template)}
          description={template.description}
          checkboxTitle={template.name}
          dataTestId={TEST_ID.TEMPLATE}
        />
      ))}
    </Container>
  );
};

const Container = styled.div(
  ({ theme }) => css`
    padding: ${theme.space('s')} ${theme.space('l')};
    height: 50vh;
    overflow-y: auto;
    width: 100%;

    ${scrollBarStyles}
  `,
);

export default TemplateDetails;
